let init = false;

export function initRecaptcha() {
	if (init) return;

	const script = document.createElement('script');
	script.src = `https://www.google.com/recaptcha/api.js?onload=onloadRecaptchafree&render=explicit&hl=${BX.message(
		'LANGUAGE_ID'
	)}`;
	document.body.appendChild(script);

	init = true;
}
